import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Dialog as MuiDialog,
  DialogContent,
  Slide,
  IconButton,
} from '@material-ui/core';
import Icon from '../elements/Icon';

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Dialog = styled(MuiDialog)`
  &.MuiDialog-root {
    z-index: ${({ $coverAll }) => ($coverAll ? '9999 !important' : '')};
  }

  .MuiDialogContent-root {
    padding: 20px;
    border-radius: 15px;

    @media (max-width: ${({ theme }) => theme.devices.mobile}) {
      border-radius: 15px 15px 0 0;
    }
  }

  .MuiDialog-container {
    align-items: center;

    @media (max-width: ${({ theme }) => theme.devices.mobile}) {
      align-items: flex-end;
    }
  }

  .MuiDialog-paper {
    background: transparent;
    box-shadow: 0 0 150px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    overflow: visible;
    padding: 0;

    @media (max-width: ${({ theme }) => theme.devices.mobile}) {
      width: 100% !important;
      max-width: 100% !important;
      margin: 30px 0 0;
      height: ${({ height }) => height || 'auto'};
    }

    .MuiDialogContent-root {
      padding: 0;
    }
  }
`;

const CloseButton = styled(IconButton)`
  z-index: 2;

  &.MuiButtonBase-root {
    position: absolute;
    right: -20px;
    top: -20px;
    width: 40px;
    height: 40px;
    font-size: 20px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
    outline: none;
    &,
    &:hover {
      background: ${({ theme }) => theme.colors.white};
    }
    @media (max-width: ${({ theme }) => theme.devices.mobile}) {
      right: 20px;
    }
  }
`;

const Modal = ({
  open,
  handleClose,
  disableBackdropClick,
  children,
  height,
  coverAll,
  ...props
}) => (
  // https://material-ui.com/api/dialog/
  <Dialog
    open={open}
    TransitionComponent={Transition}
    keepMounted
    disableBackdropClick={disableBackdropClick}
    data-testid="modal-container"
    className={!open ? 'modal-closed' : ''}
    onClose={handleClose}
    height={height}
    $coverAll={coverAll}
    {...props}
  >
    <DialogContent>
      {handleClose && (
        <CloseButton
          onClick={handleClose}
          color="primary"
          data-testid="close-button"
        >
          <Icon icon={['fas', 'times']} />
        </CloseButton>
      )}
      {children}
    </DialogContent>
  </Dialog>
);

Modal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  disableBackdropClick: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]),
  height: PropTypes.string,
  coverAll: PropTypes.bool,
};

export default Modal;
